/** Marketplace Information */
export const marketplaceTabFields = [
  { name: "marketplaceName", label: "Marketplace Name", type: "text", readonly: false },
  { name: "marketplaceOrderId", label: "Marketplace Order ID", type: "text", readonly: false },
  { name: "omsOrderId", label: "OMS Order ID", type: "text", readonly: false },
  {
    name: "orderType",
    label: "Order Type",
    type: "select",
    options: ["Sales Order", "Return Order"],
    readonly: false,
  },
  { name: "orderDate", label: "Order Date", type: "date", readonly: false },
  {
    name: "orderStatus",
    label: "Order Status",
    type: "select",
    options: ["New", "Confirmed", "Packed", "Shipped", "Delivered", "Cancelled"],
  },
  {
    name: "orderPriority",
    label: "Order Priority",
    type: "select",
    options: ["Low", "Normal", "High"],
  },
  {
    name: "fulfillmentType",
    label: "Fulfillment Type",
    type: "select",
    options: ["Marketplace", "Seller Fulfilled"],
  },
  { name: "paymentMode", label: "Payment Mode", type: "text", readonly: false },
  {
    name: "paymentStatus",
    label: "Payment Status",
    type: "select",
    options: ["Pending", "Paid", "Failed", "Refunded"],
    readonly: false,
  },
  { name: "currency", label: "Currency", type: "text", readonly: false },
];

/** Customer Information */
export const customerTabFields = [
  { name: "customerName", label: "Customer Name", type: "text", readonly: false },
  { name: "customerEmail", label: "Customer Email", type: "email", readonly: false },
  { name: "customerPhone", label: "Customer Phone", type: "text", readonly: false },
  { name: "shippingAddress", label: "Shipping Address", type: "textarea", readonly: false },
  { name: "city", label: "City", type: "text", readonly: false },
  { name: "state", label: "State", type: "text", readonly: false },
  { name: "pincode", label: "Pincode", type: "text", readonly: false },
  { name: "country", label: "Country", type: "text", readonly: false },
  { name: "billingAddress", label: "Billing Address", type: "textarea", readonly: false },
];

/** Fulfillment & Logistics Info */
export const fulfillmentTabFields = [
  { name: "fulfillmentCenterId", label: "Fulfillment Center ID", type: "text" },
  { name: "dispatchLocation", label: "Dispatch Location", type: "text" },
  {
    name: "shippingProvider",
    label: "Shipping Provider",
    type: "select",
    options: ["Marketplace Assigned", "Seller Assigned"],
  },
  { name: "trackingId", label: "Tracking ID / AWB", type: "text" },
  {
    name: "shippingServiceType",
    label: "Shipping Service Type",
    type: "select",
    options: ["Standard", "Express", "Same Day"],
  },
  { name: "pickupScheduledDate", label: "Pickup Scheduled Date", type: "date" },
  { name: "expectedDeliveryDate", label: "Expected Delivery Date", type: "date" },
  {
    name: "packagingType",
    label: "Packaging Type",
    type: "select",
    options: ["Box", "Poly Mailer", "Carton"],
  },
  { name: "labelInvoiceUrl", label: "Label / Invoice URL", type: "text", readonly: false },
];

/** Financial & Settlement Info */
export const financialTabFields = [
  { name: "itemPrice", label: "Item Price", type: "number", readonly: false },
  { name: "shippingCharge", label: "Shipping Charge", type: "number", readonly: false },
  { name: "commissionFee", label: "Commission Fee", type: "number", readonly: false },
  { name: "gstOnCommission", label: "GST on Commission", type: "number", readonly: false },
  { name: "settlementAmount", label: "Settlement Amount", type: "number", readonly: false },
  { name: "settlementDate", label: "Settlement Date", type: "date", readonly: false },
];

/** Return / Replacement + line-level details */
export const returnLineTabFields = [
  { name: "returnRequestId", label: "Return Request ID", type: "text", readonly: false },
  {
    name: "returnType",
    label: "Return Type",
    type: "select",
    options: ["Return", "Replacement"],
    readonly: false,
  },
  { name: "returnReason", label: "Return Reason", type: "text", readonly: false },
  {
    name: "returnStatus",
    label: "Return Status",
    type: "select",
    options: ["Pending", "Acknowledged", "Approved", "Closed"],

  },
  { name: "replacementOrderId", label: "Replacement Order ID", type: "text", readonly: false },
  { name: "orderLineId", label: "Order Line ID", type: "text", readonly: false },
  {
    name: "sku",
    label: "SKU / Item Code",
    type: "text",
    readonly: false,
  },
  {
    name: "skuDescription",
    label: "SKU Description",
    type: "text",
    readonly: false,
  },
  {
    name: "marketplaceListingId",
    label: "Marketplace Listing ID",
    type: "text",
    readonly: false,
  },
  {
    name: "quantityOrdered",
    label: "Quantity Ordered",
    type: "number",
    readonly: false,
  },
  {
    name: "quantityConfirmed",
    label: "Quantity Confirmed",
    type: "number",
  },
  {
    name: "unitPrice",
    label: "Unit Price",
    type: "number",
    readonly: false,
  },
  {
    name: "totalLineValue",
    label: "Total Line Value",
    type: "number",
    readonly: false,
  },
  { name: "taxPercent", label: "Tax %", type: "number", readonly: false },
  { name: "taxAmount", label: "Tax Amount", type: "number", readonly: false },
  { name: "discount", label: "Discount / Promotion", type: "number", readonly: false },
  { name: "netPayable", label: "Net Payable", type: "number", readonly: false },
];

export const orderFields = [
  ...marketplaceTabFields,
  ...customerTabFields,
  ...fulfillmentTabFields,
  ...financialTabFields,
  ...returnLineTabFields,
];
